import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../img/logobranco.png';

interface HeaderProps {
  onMenuButtonClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuButtonClick }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-primary text-white sticky top-0 z-40 shadow-lg">
      <div className="px-6 py-4 flex items-center justify-between">
        <img
          src={logo}
          alt="SinalInvest Logo"
          className="h-10 cursor-pointer"
          style={{ filter: 'brightness(0) invert(1)' }}
          onClick={() => navigate('/dashboard')}
        />
        <div className="flex items-center gap-2">
          <button
            onClick={onMenuButtonClick}
            className="md:hidden p-2 rounded-md hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            aria-label="Abrir menu"
          >
            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
